import React from 'react'
import { Link } from 'gatsby'
import logo from "./images/lhcpapclogoonly.jpg"

const Header = ({ siteTitle }) => (
  <div>
    {/* Checkbox Hack for Mobile Menu */}
    <input className="menu-btn" type="checkbox" id="menu-btn" />
    
    <div id="header">			
                
        <h1 id="logo-text">
          <Link to="/">
            <img src={logo} alt={siteTitle} />
            <div className="logo-text">
              <div className="logo-main">Lawrence Hoffman, CPA, PC</div>
              <div className="logo-subtitle">Certified Public Accountants</div>
            </div>
          </Link>
        </h1>		
        
        
        <div id="header-links">
          <a href="tel:+15166259051" className="header-phone">
            <span className="phone-number">(516) 625-9051</span>
          </a>
          <Link to="/contact/" className="header-cta">Free Consultation</Link>
        </div>		
        
        <label className="menu-icon" htmlFor="menu-btn"><span className="navicon"></span></label>
              
    </div>
    
    <div id="menu">
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/computer-consulting/">IT Consulting</Link></li>
        <li className="last"><Link to="/contact/">Contact Us</Link></li>
      </ul>
    </div>	
  </div>
)

export default Header
